import React from "react";
import MenuItem from "@material-ui/core/MenuItem";
import Zoom from "@material-ui/core/Zoom";
import CloseRounded from "@material-ui/icons/CloseRounded";
import NotificationsNoneIcon from "@material-ui/icons/NotificationsNone";
import NotificationsActiveIcon from "@material-ui/icons/NotificationsActive";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import PhoneCallbackIcon from '@material-ui/icons/PhoneCallback';
import PhoneMissedIcon from '@material-ui/icons/PhoneMissed';
import HeadsetMicIcon from '@material-ui/icons/HeadsetMic';
import { Tooltip, IconButton } from "@material-ui/core";
import { ContactPhoneRounded, ContactSupportRounded, ContactSupportSharp, PersonAddSharp } from "@material-ui/icons";
import { getTeamDetails } from "../../views/common/helper";

const PushNotificationV2 = (props) => {
    const { 
        notification, 
        index, 
        onClickNotification, 
        removeNotification, 
        formatNotificationTime,
        classes 
    } = props;

    // Function to truncate text with optional character limit (default: 10)
    const truncateText = (text, maxLength = 10) => {
        if (!text) return '';
        const textStr = String(text);
        if (textStr.length <= maxLength) return textStr;
        return textStr.substring(0, maxLength) + '...';
    };

    // Function to parse DD/MM/YYYY HH:mm:ss format to Date object
    const parseCallbackDate = (dateString) => {
        if (!dateString) return null;
        
        // Check if it's already a valid date object or ISO string
        const testDate = new Date(dateString);
        if (!isNaN(testDate.getTime()) && !dateString.includes('/')) {
            return testDate;
        }
        
        // Parse DD/MM/YYYY HH:mm:ss format
        const parts = dateString.split(' ');
        if (parts.length === 2) {
            const [datePart, timePart] = parts;
            const [day, month, year] = datePart.split('/');
            const [hours, minutes, seconds] = timePart.split(':');
            
            // Create date in MM/DD/YYYY format (JavaScript standard)
            return new Date(year, month - 1, day, hours, minutes, seconds);
        }
        
        return new Date(dateString);
    };

    const getNotificationIcon = (type) => {
        // You can extend this to show different icons based on notification type
        switch (type) {
            case 'new_prospect':
                return <PersonAddSharp style={{ fontSize: 50, color: 'black' }} />
            case 'duplicate_prospect':
                return <PersonAddSharp style={{ fontSize: 50, color: 'black' }} />
            case 'repeat_prospect':
                return <PersonAddSharp style={{ fontSize: 50, color: 'black' }} />
            case 'callback_reminder':
            case 'followups':
                return <CalendarTodayIcon style={{ fontSize: 50, color: 'black' }} />
            case 'missed_call':
                return <PhoneMissedIcon style={{ fontSize: 50, color: '#f44336' }} />
            case 'received_call':
                return <PhoneCallbackIcon style={{ fontSize: 50, color: '#4caf50' }} />
            case 'support-ticket':
                return <ContactPhoneRounded style={{ fontSize: 50, color: 'black' }} />
            case 'alert':
                return <NotificationsActiveIcon style={{ fontSize: 50, color: 'black' }} />
            default:
                return <ContactPhoneRounded style={{ fontSize: 50, color: 'black' }} />;
        }
    };

    return (
        <MenuItem
            className={classes.notificationItem}
            onClick={() => onClickNotification(notification)}
            style={{
                backgroundColor: notification.read === 0 ? 'rgba(0, 0, 0, 0.02)' : '#fff'
            }}
        >
            <div style={{ display: 'flex', alignItems: 'center', width: '100%', position: 'relative', wordWrap: 'break-word', paddingRight: '40px' }}>
                {notification.read === 0 && (
                    <div className={{}} />
                )}

                {(() => {
                    switch (notification.type) {
                        case 'missed_call':
                            return (
                                <>
                                    {/* 1st Grid - Missed Call Content */}
                                    <div style={{ flex: 1, paddingRight: 16 }}>
                                        <div style={{ fontSize: 14, fontWeight: 500, marginBottom: 4 }}>
                                            {notification.callType || 'Missed Call'} on {notification.telephony || 'IVR / Phone'} 
                                            {notification.agentName && (
                                                <Tooltip title={notification.agentName} arrow>
                                                    <span> {truncateText(notification.agentName, 10)}</span>
                                                </Tooltip>
                                            )}
                                        </div>
                                        <div style={{ fontSize: 14, fontWeight: 600, color: '#f44336', marginBottom: 4 }}>
                                            <Tooltip title={notification.firstName || ''} arrow>
                                                <span>{truncateText(notification.firstName, 10)}</span>
                                            </Tooltip>
                                        </div>
                                    </div>
                                    {/* 2nd Grid - Date Fields */}
                                    <div style={{ width: 120, paddingRight: 16 }}>
                                        <div style={{ fontSize: 12, color: '#666', marginBottom: 4 }}>
                                            {formatNotificationTime(notification.createdOn)}
                                        </div>
                                    </div>
                                    {/* 3rd Grid - Icon */}
                                    <div style={{ width: 60, height: 60, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        {getNotificationIcon(notification.type)}
                                    </div>
                                </>
                            );
                        case 'received_call':
                            return (
                                <>
                                    {/* 1st Grid - Received Call Content */}
                                    <div style={{ flex: 1, paddingRight: 16 }}>
                                        <div style={{ fontSize: 14, fontWeight: 500, marginBottom: 4 }}>
                                            {notification.callType || 'Received Call'} on {notification.telephony || 'IVR / Phone'} 
                                            {notification.agentName && (
                                                <Tooltip title={notification.agentName} arrow>
                                                    <span> {truncateText(notification.agentName, 10)}</span>
                                                </Tooltip>
                                            )}
                                        </div>
                                        <div style={{ fontSize: 14, fontWeight: 600, color: '#4caf50', marginBottom: 4 }}>
                                            <Tooltip title={notification.firstName || ''} arrow>
                                                <span>{truncateText(notification.firstName, 10)}</span>
                                            </Tooltip>
                                        </div>
                                    </div>
                                    {/* 2nd Grid - Date Fields */}
                                    <div style={{ width: 120, paddingRight: 16 }}>
                                        <div style={{ fontSize: 12, color: '#666', marginBottom: 4 }}>
                                            {formatNotificationTime(notification.createdOn)}
                                        </div>
                                    </div>
                                    {/* 3rd Grid - Icon */}
                                    <div style={{ width: 60, height: 60, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        {getNotificationIcon(notification.type)}
                                    </div>
                                </>
                            );
                        case 'new_prospect':
                        case 'duplicate_prospect':
                        case 'repeat_prospect':
                            return (
                                <>
                                    {/* 1st Grid - New Prospect Content */}
                                    <div style={{ flex: 1, paddingRight: 16 }}>
                                        <div style={{ fontSize: 12, fontWeight: 600, color: 'black', marginBottom: 0 }}>
                                            New Prospect Created {notification.source || 'Manually'} 
                                        </div>
                                        <div style={{ fontSize: 10, fontWeight: 600, color: '#666', marginBottom: 0 }}>
                                            <Tooltip title={notification.firstName || ''} arrow>
                                                <span>{truncateText(notification.firstName, 10)}</span>
                                            </Tooltip>
                                        </div>
                                        <div style={{ fontSize: 10, fontWeight: 600, color: '#666', marginBottom: 0 }}>
                                            Campaign - {notification.campaignName || notification.campaign}
                                        </div>
                                      
                                    </div>
                                    {/* 2nd Grid - Date Fields */}
                                    <div style={{ width: 120, paddingRight: 16 }}>
                                    

                                    <div style={{ fontSize: 12, color: '#666' }}>
                                            <Tooltip title={(getTeamDetails(notification.agentName) && getTeamDetails(notification.agentName).first_name) || notification.agentName || ''} arrow>
                                                <span>{truncateText((getTeamDetails(notification.agentName) && getTeamDetails(notification.agentName).first_name) || notification.agentName || '', 10)}</span>
                                            </Tooltip>
                                        </div>
                                        <div style={{ fontSize: 12, color: '#666', marginBottom: 4 }}>
                                            {formatNotificationTime(notification.createdOn)}
                                        </div>
                                        <div style={{ fontSize: 12, color: '#666' }}>
                                            By - {notification.createdBy || 'Admin'}
                                        </div>
                                    </div>
                                    {/* 3rd Grid - Icon */}
                                    <div style={{ width: 60, height: 60, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        {getNotificationIcon(notification.type)}
                                    </div>
                                </>
                            );
                        case 'followups':
                        case 'callback_reminder':
                            return (
                                <>
                                    {/* 1st Grid - Followups Content */}
                                    <div style={{ flex: 1, paddingRight: 16 }}>
                                        <div style={{ fontSize: 12, fontWeight: 600, color: 'black', marginBottom: 0 }}>
                                            Followups of
                                        </div>
                                        <div style={{ fontSize: 10, fontWeight: 600,  color: '#666' , marginBottom: 0 }}>
                                            <Tooltip title={notification.firstName || ''} arrow>
                                                <span>{truncateText(notification.firstName, 10)}</span>
                                            </Tooltip>
                                        </div>
                                        <div style={{ fontSize: 10, fontWeight: 600,  color: '#666' , marginBottom: 0 }}>
                                            Campaign - {notification.campaignName || notification.campaign}
                                        </div>
                                    </div>
                                    {/* 2nd Grid - Date Fields */}
                                    <div style={{ width: 120, paddingRight: 16 }}>
                                    <div style={{ fontSize: 12, color: '#666' }}>
                                            <Tooltip title={(getTeamDetails(notification.agentName) && getTeamDetails(notification.agentName).first_name) || notification.agentName || ''} arrow>
                                                <span>{truncateText((getTeamDetails(notification.agentName) && getTeamDetails(notification.agentName).first_name) || notification.agentName || '', 10)}</span>
                                            </Tooltip>
                                        </div>
                                        <div style={{ fontSize: 12, color: '#666', marginBottom: 4 }}>
                                            {formatNotificationTime(parseCallbackDate(notification.callback))}
                                        </div>
                                    </div>
                                    {/* 3rd Grid - Icon */}
                                    <div style={{ width: 60, height: 60, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        {getNotificationIcon(notification.type)}
                                    </div>
                                </>
                            );
                        case 'support-ticket':
                            return (
                                <>
                                    {/* 1st Grid - Support Ticket Content */}
                                    <div style={{ flex: 1, paddingRight: 16 }}>
                                        <div style={{ fontSize: 12, fontWeight: 500, marginBottom: 0, color: 'black' }}>
                                            Ticket ({notification.status}) for ({notification.category})
                                        </div>
                                        <div style={{ fontSize: 10, color: '#666', marginBottom: 0 }}>
                                            for - 
                                            <Tooltip title={notification.customer || notification.admin || ''} arrow>
                                                <span> {truncateText(notification.customer || notification.admin, 10)}</span>
                                            </Tooltip>
                                        </div>
                                        <div style={{ fontSize: 10, color: '#666', marginBottom: 0 }}>
                                            Allocated to -
                                            <Tooltip title={(getTeamDetails(notification.manager) && getTeamDetails(notification.manager).first_name) || notification.manager || ''} arrow>
                                                <span> {truncateText((getTeamDetails(notification.manager) && getTeamDetails(notification.manager).first_name) || notification.manager || '', 10)}</span>
                                            </Tooltip>
                                        </div>
                                    </div>
                                    {/* 2nd Grid - Date Fields */}
                                    <div style={{ paddingRight: 16 }}>
                                        <div style={{ fontSize: 12, color: '#666', marginBottom: 0 }}>
                                            {formatNotificationTime(notification.createdOn)}
                                        </div>
                                        {notification.followupDate && (
                                            <div style={{ fontSize: 12, color: '#666' }}>
                                                Followups - {formatNotificationTime(notification.scheduledTime)}
                                            </div>
                                        )}
                                    </div>
                                    {/* 3rd Grid - Icon */}
                                    <div style={{ width: 60, height: 60, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        {getNotificationIcon(notification.type)}
                                    </div>
                                </>
                            );
                        default:
                            return (
                                <>
                                    {/* 1st Grid - Default Content */}
                                    <div style={{ flex: 1, paddingRight: 16 }}>
                                        <div style={{ fontSize: 14, fontWeight: 500, marginBottom: 4 }}>
                                            {notification.isHtml ? (
                                                <div dangerouslySetInnerHTML={{ __html: notification.message }} />
                                            ) : (
                                                notification.message
                                            )}
                                        </div>
                                        <div style={{ fontSize: 12, color: '#666' }}>
                                            <Tooltip title={notification.agentName || notification.createdBy || ''} arrow>
                                                <span>{truncateText(notification.agentName || notification.createdBy, 10)}</span>
                                            </Tooltip>
                                        </div>
                                    </div>
                                    {/* 2nd Grid - Date Fields */}
                                    <div style={{ width: 120, paddingRight: 16 }}>
                                        <div style={{ fontSize: 12, color: '#666', marginBottom: 4 }}>
                                            {formatNotificationTime(notification.createdOn)}
                                        </div>
                                    </div>
                                    {/* 3rd Grid - Icon */}
                                    <div style={{ width: 60, height: 60, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        {getNotificationIcon(notification.type)}
                                    </div>
                                </>
                            );
                    }
                })()}

                <Tooltip title="Remove" arrow TransitionComponent={Zoom}>
                    <IconButton
                        size="small"
                        className={classes.closeButton}
                        style={{
                            color: '#F44336',
                            position: 'absolute',
                            top: 4,
                            right: 4,
                            padding: 4,
                            zIndex: 10
                        }}
                        onClick={(e) => {
                            e.stopPropagation();
                            removeNotification(notification);
                        }}
                    >
                        <CloseRounded fontSize="small" />
                    </IconButton>
                </Tooltip>
            </div>
        </MenuItem>
    );
};

export default PushNotificationV2;
